"use client";

import {
  createContext,
  type FC,
  type ReactNode,
  useCallback,
  useContext,
} from "react";
import { useServerParams } from "@money/frontend/components/hooks/use.server.params.tsx";

const Fetch = createContext({
  baseUrl: "",
  interceptor: {
    before: async (
      // @ts-ignore
      input: RequestInfo | URL,
      // @ts-ignore
      init?: RequestInit
    ): Promise<boolean> => Promise.resolve(true),
    after: async (
      // @ts-ignore
      input: RequestInfo | URL,
      // @ts-ignore
      init?: RequestInit,
      // @ts-ignore
      body: any
    ): Promise<boolean> => Promise.resolve(true),
  },
});

export const FetchContext: FC<{ children: ReactNode }> = ({ children }) => {
  const { backendUrl } = useServerParams();
  return (
    <Fetch.Provider
      value={{
        baseUrl: backendUrl,
        interceptor: { before: async () => true, after: async () => true },
      }}
    >
      {children}
    </Fetch.Provider>
  );
};

export const useFetch = () => {
  const context = useContext(Fetch);
  return useCallback(
    async function (
      input: RequestInfo | URL,
      init?: RequestInit
    ): Promise<Response> {
      if (!(await context.interceptor.before(input, init))) {
        // @ts-ignore
        return;
      }

      const load = await fetch(context.baseUrl + input, {
        ...init,
        headers: {
          "Content-Type": "application/json",
          ...(init?.headers || {}),
        },
        credentials: "include",
      });

      // if (
      //   !(await context.interceptor.after(
      //     input,
      //     init,
      //     JSON.parse(await load.text())
      //   ))
      // ) {
      //   return false;
      // }

      return load;
    },
    [context]
  );
};
